import { createContext, useContext, useState, useEffect } from "react";
import Url, { TQueryParams } from "../Url";
import Path, {TQueryParamsNull} from "./Path";

export interface IPathContext {
    data?:any
    path:string;
    hash:string;
    query:TQueryParams;
    setPath:(url:string, title?:string, data?:any)=>void;
    setHash:(hash:string)=>void
    setQuery:(query:TQueryParamsNull)=>void;
}
const PathContext = createContext<IPathContext>({path:"",hash:"",query:{},setPath:()=>{},setQuery:()=>{},setHash:()=>{}})
const g_path = new Path().parse(document.location.href)

export const usePath = () => useContext(PathContext)

export default function PathProvider(props:{children:any}){
    const [path,_setPath] = useState<string>(g_path.path);
    const [query,_setQuery] = useState<TQueryParams>(g_path.query);
    const [hash,_setHash] = useState<string>(g_path.hash)
    const [data,_setData] = useState<any>(null)

    const _update = (url:Path) => {
      _setPath(url.path)
      _setQuery({...url.query})
      _setHash(url.hash)
      _setData(url.data)
    }

    useEffect(() => {
        if (path!=g_path.path) _update(g_path)    // before mount, route changed
        g_path.addListener("change", _update)
        return () => {g_path.removeListener("change", _update)}
      },[])
    const setPath = (url:string|Url,title:string="",data:any={}) => g_path.set(url,title,data)
    const setQuery = (query:TQueryParamsNull) => { g_path.setParams(query); _setQuery({...g_path.query}) }
    const setHash = (hash:string) => g_path.setHash(hash)

    return <PathContext.Provider value={{data,path,query,hash,setPath,setQuery,setHash}}>
        {props.children}
    </PathContext.Provider>
}